/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM, displayTypes, centerAbsolutely } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : CONTENT : POLL : STYLES --------------- ++++++++++ */
export default {
	poll: {

	}
};
